import React, { useRef } from 'react';

import { AvailableConferences } from '../components/conference/AvailableConferences';

import { useCreateConfMutation } from '../services/RttBridgeApi';

import './ConnectionView.css'


interface ConnectionViewProps {
    // Props for the ConnectionView component
}

const ConnectionView: React.FC<ConnectionViewProps> = (props) => {
    // Declare state and variables 
    const confNameInputRef = useRef<HTMLInputElement>(null);


    const [createConf] = useCreateConfMutation(undefined)

    // Declare a function for making the API request to Create a new conference
    const handelCreateConference = (event: any) => {
        event.preventDefault()

        //Create conference
        if (confNameInputRef !== null) {
            const body = { name: confNameInputRef.current!.value }
            createConf({ body })
                .unwrap()
                .then((payload) => console.log('fulfilled', payload))
                .catch((error) => console.error('rejected', error));

            confNameInputRef.current!.value = ''

        }
    }

    return (
        <div className='container'>

            {/* Render the input field to get a name for a new conference and a create button */}
            <div className='create-conf'>
                <h2>Create Conference</h2>
                <form onSubmit={handelCreateConference}>
                    <p >Enter a name :</p>
                    <input id="confNameInput" ref={confNameInputRef} placeholder="Type a name here..." />
                    <button> Create</button>
                </form>
            </div>

            <hr />
            {/* List of Available Conferences */}
            <div>
                <AvailableConferences />
                <hr />
            </div>
        </ div>
    );
};

export default ConnectionView;
